export const average = (arr) => Math.floor(arr.reduce((acc, v) => acc + v) / arr.length)
